import { Component, inject } from '@angular/core';
import { LocalStorageService } from '../../core/service/localStorage/local-storage.service';
import moment from 'moment';
import { DomainConfigService } from '../../core/service/domainConfig/domain-config.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  private domainConfigService = inject(DomainConfigService);

  userDetails:any;
  currentYear = moment().format('YYYY');
  companyName = 'Crizac Ltd';
  
  constructor(
      private LocalStorageService : LocalStorageService
  ) { }

  async ngOnInit(): Promise<void>{
    this.userDetails = await this.LocalStorageService.getKeyIndexedDbKey(
      'currentUser'
    );
    this.setupDomainBranding();
  }

  private setupDomainBranding(): void {
    this.companyName = this.domainConfigService.getCompanyName();
  }
}
